if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        container.querySelectorAll(':scope > [data-modal-fallback-media]').forEach((element) => element.remove());

        const activeMedia =
          this.findOpenedMedia(container) ||
          this.createFallbackMedia(container) ||
          container.querySelector(':scope > [data-media-id]');
        if (!activeMedia) return;

        container.querySelectorAll(':scope > [data-media-id]').forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });
        this.hydrateMedia(activeMedia);
        const deferredMedia = activeMedia.matches('deferred-media') ? activeMedia : activeMedia.querySelector('deferred-media');
        const activeMediaTemplate = deferredMedia?.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        // Centre on the media itself; the deferred wrapper div is only as wide as the viewport.
        const mediaElement = activeMedia.querySelector(':scope > img') || activeMedia;
        const activeMediaWidth = mediaElement.width || mediaElement.getBoundingClientRect().width;
        container.scrollLeft = (activeMediaWidth - container.clientWidth) / 2;

        if (
          deferredMedia &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          deferredMedia.loadContent();
      }

      // Openers carry the bare media id; modal items are keyed "<section id>-<media id>".
      findOpenedMedia(container) {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return null;

        const items = Array.from(container.querySelectorAll(':scope > [data-media-id]'));
        const keys = [mediaId];
        if (this.dataset.section) keys.unshift(`${this.dataset.section}-${mediaId}`);

        for (const key of keys) {
          const match = items.find((element) => element.dataset.mediaId === key);
          if (match) return match;
        }
        return items.find((element) => element.dataset.mediaId.endsWith(`-${mediaId}`)) || null;
      }

      // Media that is not in the modal list: show the opener's own image instead of an empty dialog.
      createFallbackMedia(container) {
        const source = this.openedBy?.closest('modal-opener')?.querySelector('.product__media img');
        const src = source?.currentSrc || source?.getAttribute('src');
        if (!src) return null;

        const wrapper = document.createElement('div');
        wrapper.dataset.mediaId = `${this.openedBy.getAttribute('data-media-id') || 'opener'}-fallback`;
        wrapper.setAttribute('data-modal-fallback-media', '');

        const image = document.createElement('img');
        image.className = 'global-media-settings global-media-settings--no-shadow';
        const srcset = source.getAttribute('srcset');
        if (srcset) {
          image.setAttribute('srcset', srcset);
          image.setAttribute('sizes', '(min-width: 750px) calc(100vw - 22rem), 1100px');
        }
        image.src = src;
        image.alt = source.getAttribute('alt') || '';
        const width = Number(source.getAttribute('width'));
        const height = Number(source.getAttribute('height'));
        if (width && height) {
          image.width = 1100;
          image.height = Math.ceil((1100 * height) / width);
        }

        wrapper.appendChild(image);
        container.prepend(wrapper);
        return wrapper;
      }

      hydrateMedia(activeMedia) {
        const template = activeMedia?.querySelector(':scope > template');
        if (!template) return;

        activeMedia.appendChild(template.content.cloneNode(true));
        template.remove();
      }
    }
  );
}
